var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 40,
    viewBox: "0 0 34 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M23.0674 8.13395C22.1643 8.13263 21.2986 7.77319 20.6602 7.13446C20.0217 6.49573 19.6627 5.62986 19.6618 4.72677V0H4.44435C3.26563 0 2.1352 0.468236 1.30172 1.30171C0.468246 2.13519 0 3.26564 0 4.44436V31.236C0.00175039 32.4136 0.470764 33.5423 1.30405 34.3744C2.13734 35.2064 3.26678 35.6738 4.44435 35.6737H22.7123C23.8899 35.6738 25.0193 35.2064 25.8526 34.3744C26.6859 33.5423 27.1549 32.4136 27.1566 31.236V8.13395H23.0674Z",
    fill: "#FF3E4C"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1565 8.13395H23.0673C22.1642 8.13263 21.2985 7.77319 20.6601 7.13446C20.0216 6.49573 19.6626 5.62986 19.6617 4.72677V0L27.1565 8.13395Z",
    fill: "#FF3E4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3787 28.1772H9.7276C8.26272 28.1772 7.0752 29.3648 7.0752 30.8297V36.9867C7.0752 38.4516 8.26272 39.6391 9.7276 39.6391H30.3787C31.8436 39.6391 33.0312 38.4516 33.0312 36.9867V30.8297C33.0312 29.3648 31.8436 28.1772 30.3787 28.1772Z",
    fill: "#FF3E4C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2517 35.2412V36.4419H14.0081V35.2412H15.2517Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1202 35.4724H19.3118V36.4418H15.7858V35.5285L17.9427 32.4385H15.8138V31.4756H19.2986V32.3889L17.1202 35.4724Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2508 31.4756V36.4418H20.0551V31.4756H21.2508Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.28 34.6994V36.4418H22.0793V31.4756H24.0183C24.6079 31.4756 25.0588 31.6209 25.3676 31.9149C25.524 32.0681 25.6462 32.2527 25.7261 32.4565C25.8061 32.6603 25.8421 32.8787 25.8317 33.0974C25.8369 33.3863 25.7651 33.6713 25.6236 33.9232C25.4794 34.1695 25.2657 34.3677 25.0092 34.493C24.6997 34.6385 24.3602 34.7093 24.0183 34.6994H23.28ZM24.6145 33.0974C24.6145 32.6625 24.3734 32.4423 23.8911 32.4368H23.28V33.7283H23.8911C24.3734 33.7338 24.6145 33.5235 24.6145 33.0974Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5754 25.1897C13.02 25.1888 12.4875 24.9677 12.095 24.5748C11.7024 24.1819 11.4816 23.6493 11.4812 23.0939V20.998H15.6712V23.0939C15.6708 23.6496 15.4498 24.1824 15.0569 24.5754C14.6639 24.9683 14.1311 25.1893 13.5754 25.1897ZM12.5531 22.0699V23.0939C12.5531 23.3652 12.6607 23.6254 12.8524 23.8174C13.0441 24.0093 13.3041 24.1174 13.5754 24.1179C13.8468 24.1174 14.107 24.0094 14.2989 23.8175C14.4909 23.6255 14.5989 23.3653 14.5993 23.0939V22.0699H12.5531Z",
    fill: "#FF3E4C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4795 20.9998H13.5803V18.899H11.4795V20.9998Z",
    fill: "#FF3E4C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.576 18.9004H15.6768V16.7996H13.576V18.9004Z",
    fill: "#FF3E4C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4795 16.8013H13.5803V14.7005H11.4795V16.8013Z",
    fill: "#FF3E4C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.576 14.7021H15.6768V12.6014H13.576V14.7021Z",
    fill: "#FF3E4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZip);
export default __webpack_public_path__ + "static/media/zip.dd9f96de19c303f5f7291e9beb078c36.svg";
export { ForwardRef as ReactComponent };